import { Tooltip } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import ContentConstants from '../contentConstants';
import { AudienceSourceType } from '../models';

const getAudienceSourceTypes = () => {
	return [
		{ name: '', displayText: <div>{ContentConstants.AUDIENCE_SOURCE_CHOOSE_YOUR_SOURCE}</div>, displayOrder: 0 },
		{
			name: AudienceSourceType.Hris.toString(),
			displayText: (
				<div>
					{ContentConstants.AUDIENCE_SOURCE_EMPLOYEE_FILE}
					<Tooltip id='hris-tooltip'>{ContentConstants.AUDIENCE_SOURCE_EMPLOYEE_FILE_TOOLTIP}</Tooltip>
				</div>
			),
			selectedDisplayText: ContentConstants.AUDIENCE_SOURCE_EMPLOYEE_FILE,
			displayOrder: 1,
		},
		{
			name: AudienceSourceType.Hierarchy.toString(),
			displayText: (
				<div>
					{ContentConstants.AUDIENCE_SOURCE_HIERARCHY_STRUCTURE}
					<Tooltip id='hierarchy-structure-tooltip'>{ContentConstants.AUDIENCE_SOURCE_HIERARCHY_STRUCTURE_TOOLTIP}</Tooltip>
				</div>
			),
			selectedDisplayText: ContentConstants.AUDIENCE_SOURCE_HIERARCHY_STRUCTURE,
			displayOrder: 2,
		},
		{
			name: AudienceSourceType.FileUpload.toString(),
			displayText: (
				<div>
					{ContentConstants.AUDIENCE_SOURCE_OTHER_SOURCE}
					<Tooltip id='other-source-tooltip'>{ContentConstants.AUDIENCE_SOURCE_OTHER_SOURCE_TOOLTIP}</Tooltip>
				</div>
			),
			selectedDisplayText: ContentConstants.AUDIENCE_SOURCE_OTHER_SOURCE,
			displayOrder: 3,
		},
	];
};

export const AudienceSourceTypeHelper = {
	getAudienceSourceTypes,
};
